import React from 'react';
import {observer} from 'mobx-react';
import './engraved-plate.scss';
import {EPBorderType, ProductCustomizationState} from '../../../product/rendering/render.def';
import {PrimaryMatWrapper} from '../../../product/components/engraved-plates/ep-extended/primary-mat-wrapper';
import {EPContent} from '../../../product/components/engraved-plates/ep-extended/ep-content';
import {FrameBuilderStore} from '../frame-builder-store';
import {placeFrameBuilderPlate} from './place-frame-builder-plate';

type Props = {
    pcs: ProductCustomizationState;
    store: FrameBuilderStore;
    centerInBottomRail?: boolean;
};

// Same plate tree as ProductRender. The bevel's left/top are this frame's origin
// (outside the moulding); the box inside it is the one renderEngravedPlate measured.
export const FrameBuilderEngravedPlate = observer(({pcs, store, centerInBottomRail}: Props) => {
    const css = pcs.css;

    if (!css?.ep_visible) {
        return null;
    }

    const placement = placeFrameBuilderPlate({
        bevelLeft: css.ep_bevel_left,
        bevelTop: css.ep_bevel_top,
        bevelWidth: css.ep_bevel_width,
        bevelHeight: css.ep_bevel_height,
        matWidth: css.pmat_width,
        matHeight: css.pmat_height,
        mouldingInches: store.frame.moulding.mouldingThickness,
        contentWidthInches: store.contentWidth,
        contentHeightInches: store.contentHeight,
        dpi: pcs.DPI,
        railBottomInches: store.frame.railBottom,
        centerInBottomRail,
    });

    if (!placement) {
        return null;
    }

    const isInnerAccent = pcs.EPBorderType === EPBorderType.InnerAccent;
    const primaryMatStyle: React.CSSProperties = {
        backgroundImage: css.ep_pmat_backgroundImage,
        left: css.ep_pmat_left,
        top: css.ep_pmat_top,
        transform: isInnerAccent ? 'translate(-50%, -50%)' : undefined,
        width: css.ep_pmat_width,
        height: css.ep_pmat_height,
        border: isInnerAccent ? css.ep_pmat_border : undefined,
    };

    return (
        <div
            id="ep_bevel"
            className="frame-builder-ep"
            style={{
                position: 'absolute',
                zIndex: 1,
                backgroundColor: css.ep_bevel_backgroundColor,
                left: placement.left,
                top: placement.top,
                width: css.ep_bevel_width,
                height: css.ep_bevel_height,
                transform: placement.scale === 1 ? undefined : `scale(${placement.scale})`,
                transformOrigin: placement.scale === 1 ? undefined : 'top left',
            }}
        >
            <PrimaryMatWrapper
                css={css}
                isInnerAccent={isInnerAccent}
            >
                <div
                    id="ep_pmat"
                    style={primaryMatStyle}
                >
                    <EPContent
                        pcs={pcs}
                        css={css}
                    />
                </div>
            </PrimaryMatWrapper>
        </div>
    );
});
